import { useState, useEffect, useRef } from "react";
import OnboardingCompletionTimerService from "@/services/OnboardingCompletionTimerService";

export const useOnboardingCompletionTimer = () => {
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const timerService = OnboardingCompletionTimerService.getInstance();

    // Get initial state
    const state = timerService.getState();
    setTimeRemaining(state.timeRemaining);
    setIsTimerActive(state.isActive);

    // Poll for updates instead of subscribing to avoid infinite loops
    const pollInterval = setInterval(() => {
      const currentState = timerService.getState();
      setTimeRemaining(currentState.timeRemaining);
      setIsTimerActive(currentState.isActive);
    }, 1000);

    intervalRef.current = pollInterval;

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const startTimer = (onComplete?: () => void) => {
    const timerService = OnboardingCompletionTimerService.getInstance();
    timerService.startTimer(
      () => {
        onComplete?.();
      },
      (timeRemaining) => {
        setTimeRemaining(timeRemaining);
      }
    );
  };

  const resumeTimer = (onComplete?: () => void) => {
    const timerService = OnboardingCompletionTimerService.getInstance();
    timerService.resumeTimer(
      () => {
        onComplete?.();
      },
      (timeRemaining) => {
        setTimeRemaining(timeRemaining);
      }
    );
  };

  const clearTimer = () => {
    const timerService = OnboardingCompletionTimerService.getInstance();
    timerService.clearTimer();
  };

  return {
    timeRemaining,
    isTimerActive,
    startTimer,
    resumeTimer,
    clearTimer
  };
};
